import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoresComponent } from './stores.component';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { StoresRoutingModule } from './stores-routing.module';
import { NbMenuModule } from '@nebular/theme';
import { StoreComponent } from './store/store.component';

@NgModule({
  declarations: [StoresComponent, StoreComponent],
  imports: [
    CommonModule,
    StoresRoutingModule,
    UbsViewContainersModule,
    NbMenuModule
  ],
  exports: [
    StoresRoutingModule
  ]

})
export class StoresModule {
 /*  public static forRoot():ModuleWithProviders<StoresModule> {
    return {
      ngModule: StoresModule,
    };
  } */
 }
